<span class="c-timeline__item__header__step-indicator">
	@if (step) {
		{{ step }}
	}
</span>

<div class="c-timeline__item__header__content">
	<div>
		@if (title) {
			<strong class="c-timeline__item__header__content__title">{{ title }}</strong>
		}
		@if (date) {
			<p class="c-vloket-text--s">{{ date | date: 'd MMMM y' }}</p>
		}
	</div>

	@if (!isCondensed && descriptions | arrayContainsOne: ['title', 'date']) {
		<fa-icon
			class="c-timeline__item__accordion-indicator"
			[icon]="isExpanded ? 'fa-chevron-up' : 'fa-chevron-down'"
		/>
	}
</div>
